import FieldId from './FieldId'

export default Object.freeze({
  CUSTOM_FIELD_01: FieldId.CUSTOM_FIELD_01,
  CUSTOM_FIELD_02: FieldId.CUSTOM_FIELD_02,
  CUSTOM_FIELD_03: FieldId.CUSTOM_FIELD_03,
})
